import React from "react";
import { Box, Typography, Link, Grid, Container, Divider, IconButton } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Facebook,
  LinkedIn,
  Email,
  Phone,
  LocationOn,
  KeyboardArrowUp
} from "@mui/icons-material";
import XIcon from "@mui/icons-material/X";
import Logo from "../src/Components/images/logo.png";

const Footer = ({ onRequestDemo }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleLinkClick = (e, link) => {
    e.preventDefault();
    if (link === "Help Center") {
      window.dispatchEvent(new Event('openChatBot'));
    } else if (link === "How it works") {
      if (location.pathname !== "/" && location.pathname !== "/home") {
        navigate("/");
        setTimeout(() => {
          const element = document.getElementById("how-it-works");
          if (element) element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      } else {
        const element = document.getElementById("how-it-works");
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }
    } else if (link === "Recruiters") {
      if (location.pathname !== "/" && location.pathname !== "/home") {
        navigate("/");
        setTimeout(() => {
          const element = document.getElementById("recruiters-section");
          if (element) element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      } else {
        const element = document.getElementById("recruiters-section");
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }
    } else if (link === "Jobseekers") {
      if (location.pathname !== "/" && location.pathname !== "/home") {
        navigate("/");
        setTimeout(() => {
          const element = document.getElementById("jobseekers-section");
          if (element) element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      } else {
        const element = document.getElementById("jobseekers-section");
        if (element) element.scrollIntoView({ behavior: "smooth" });
      }
    } else if (link === "Privacy Policy") {
      navigate("/privacy-policy");
    } else if (link === "Terms and Conditions") {
      navigate("/terms-and-conditions");
    } else if (link === "AI Terms of Use") {
      navigate("/ai-terms-of-use");
    } else if (link === "About" || link === "About Us") {
      navigate("/about-us");
    } else if (link === "Request a Demo") {
      onRequestDemo();
    } else if (link === "Blog") {
      navigate("/blog");
    }
  };

  const footerSections = [
    {
      title: "Product",
      links: ["About Us", "How it works", "Jobseekers", "Recruiters"],
    },
    {
      title: "Resources",
      links: ["Blog", "Help Center", "Request a Demo",],
    },
    {
      title: "Company",
      links: ["Privacy Policy", "Terms and Conditions", "AI Terms of Use"],
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF", // White background
        color: "#0B1121",
        pt: { xs: 8, md: 10 },
        pb: 6,
        width: "100%",
        fontFamily: "'Poppins', sans-serif",
        "& *": { fontFamily: "'Poppins', sans-serif" }
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Logo and Contact Section */}
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 3 }}>
              {/* Original Logo */}
              <Box
                component="img"
                src={Logo}
                alt="Jobsnprofiles | Logo"
                sx={{
                  width: { xs: 150, md: 180 },
                  mb: 2
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  lineHeight: 1.8,
                  maxWidth: "300px",
                  mb: 3,
                  color: "#64748B" // Slate grey
                }}
              >
                The smarter way to connect recruiters with IT talent. Fast, efficient, and reliable.
              </Typography>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Email sx={{ fontSize: 20, color: "#FF6B00" }} />
                  <Typography variant="body2" sx={{ color: "#334155" }}>Contact@jobsnprofiles.com</Typography>
                </Box>
                {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Phone sx={{ fontSize: 20, color: "#FF6B00" }} />
                  <Typography variant="body2" sx={{ color: "#334155" }}>+1 (555) 123-4567</Typography>
                </Box> */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <LocationOn sx={{ fontSize: 20, color: "#FF6B00" }} />
                  <Typography variant="body2" sx={{ color: "#334155", lineHeight: 1.8 }}>
                    392 E Winchester St, Suite 201,<br />
                    Salt Lake City, Utah 84107
                    USA
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>

          {/* Links Sections */}
          {footerSections.map((section) => (
            <Grid item xs={6} sm={4} md={2.6} key={section.title}>
              <Typography
                variant="subtitle1"
                sx={{
                  color: "#0B1121", // Dark Navy
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                {section.title}
              </Typography>
              <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0 }}>
                {section.links.map((link) => (
                  <Box component="li" key={link} sx={{ mb: 2 }}>
                    <Link
                      href="#"
                      underline="none"
                      onClick={(e) => handleLinkClick(e, link)}
                      sx={{
                        color: "#64748B",
                        fontSize: "14px",
                        transition: "color 0.2s",
                        "&:hover": {
                          color: "#FF6B00", // Orange on hover
                        },
                        cursor: "pointer",
                      }}
                    >
                      {link}
                    </Link>
                  </Box>
                ))}
              </Box>
            </Grid>
          ))}
        </Grid>

        <Divider sx={{ borderColor: "#E2E8F0", mt: 0, mb: 1 }} />

        {/* Bottom Bar */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ color: "#94A3B8" }}>
            © {new Date().getFullYear()}{" "}
            <Box component="span" sx={{ color: "#6C2F26", fontWeight: 700 }}>
              Jobs
            </Box>
            <Box component="span" sx={{ color: "#6C2F26", fontWeight: 700 }}>
              'n'
            </Box>
            <Box component="span" sx={{ color: "#FF6B00", fontWeight: 700 }}>
              Profiles
            </Box>
            . All rights reserved. |{" "}
            <Link
              href="https://bs.jobsnprofiles.com/privacy-policy"
              sx={{ color: "#94A3B8", textDecoration: "none", "&:hover": { color: "#FF6B00" } }}
            >
              Privacy Policy
            </Link>{" "}
            |{" "}
            <Link
              href="https://bs.jobsnprofiles.com/terms-and-conditions"
              sx={{ color: "#94A3B8", textDecoration: "none", "&:hover": { color: "#FF6B00" } }}
            >
              Terms and Conditions
            </Link>{" "}
            |{" "}
            <Link
              href="/ai-terms-of-use"
              sx={{ color: "#94A3B8", textDecoration: "none", "&:hover": { color: "#FF6B00" } }}
            >
              AI Terms of Use
            </Link>
          </Typography>

          <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
            {[
              { icon: <XIcon />, label: "Twitter", link: "https://x.com/jobsnprofiles" },
              { icon: <LinkedIn />, label: "LinkedIn", link: "https://www.linkedin.com/company/jobsnprofiles" },
              { icon: <Facebook />, label: "Facebook", link: "https://www.facebook.com/Jobsnprofile" },
            ].map((social) => (
              <Link
                key={social.label}
                href={social.link}
                underline="none"
                sx={{
                  color: "#64748B",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  transition: "color 0.2s",
                  "&:hover": {
                    color: "#FF6B00",
                  },
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {social.label}
                </Typography>
              </Link>
            ))}

            {/* Scroll to Top Button */}
            <IconButton
              onClick={scrollToTop}
              sx={{
                ml: 2,
                backgroundColor: "rgba(255, 107, 0, 0.1)",
                color: "#FF6B00",
                "&:hover": {
                  backgroundColor: "#FF6B00",
                  color: "white",
                },
              }}
              aria-label="scroll to top"
            >
              <KeyboardArrowUp />
            </IconButton>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
